import React from "react";
import styles from "./RsvpGuestStory.module.css";
import { Layout } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp3.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const RsvpGuestStory = () => {
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const navigate = useNavigate();
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  return (
    <div style={myStyle} className={styles.mainContainer}>
        <Header
          mainHeader={styles.headerColor}
          isProfile={true}
          title={"RSVP"}
          style={{ padding: 0, background: "var(--white-color)", height: 85 }}
          onBackClick={()=>navigate(-1)} 
        />
      <div className={styles.mainDiv}>
        <div className={styles.innerDiv}>
          <div className={styles.innerDiv2}>
            <TextComponent textClass={styles.title} text="Our Story" />
            <TextComponent
              textClass={styles.text}
              text={rsvpData?.our_story}
            />
            <BiSolidChevronRightCircle
              className={styles.con1}
              cursor={"pointer"}
              size={30}
              onClick={() => navigate("/rsvp/rsvpGuestTidbits")}
            />
          </div>
        </div>
        {/* <div className={styles.imgContainer}>
          <img className={styles.innerImg} src={Rsvp} />
        </div> */}
      </div>
    </div>
  );
};

export default RsvpGuestStory;
